import React from 'react';
import { Tooltip } from 'components/common';

const ResultsTable = ({ config, postOnChangeResponse }) => {
  if (!config.post_on_change || !postOnChangeResponse || !postOnChangeResponse.line_item_prices || postOnChangeResponse.line_item_prices.length === 0) {
    return null;
  }

  return (
    <table className="float-right full_width">
      <tbody>
        {config.show_number_of_sheets != false && postOnChangeResponse.number_of_sheets != undefined && (
        <tr key="number_of_sheets">
          <td>
            {t('quote_builder.number_of_sheets')}
            {postOnChangeResponse.sheet_description != undefined && <> &nbsp; ({postOnChangeResponse.sheet_description}) </> }
            {postOnChangeResponse.num_of_drawings_in_set > 1 && (
              <Tooltip title={t('quote_builder.num_of_drawings_in_set_description').replace('%s', postOnChangeResponse.num_of_drawings_in_set)} />)}
          </td>
          <td className="align-right"> {postOnChangeResponse.number_of_sheets}</td>
        </tr>
        ) }

        { postOnChangeResponse.result_info_rows.map( (resultInfoRow) => {
          return (<tr key={resultInfoRow.key}>
            <td>
              {t(resultInfoRow.key)}
              {resultInfoRow.tooltip_text != undefined && (
                <Tooltip title={resultInfoRow.tooltip_text} />)}
            </td>
            <td className="align-right">
              {resultInfoRow.value != undefined && resultInfoRow.value}
            </td>
          </tr>)
        } )}

        {postOnChangeResponse.line_item_prices.map((line_item_price) => {
          return (
            <tr key={line_item_price.title}>
              <td> {line_item_price.title} {line_item_price.notes != '' && <Tooltip key={line_item_price.notes} title={line_item_price.notes} />} </td>
              <td className="align-right">
              {line_item_price.price_formatted}

               {line_item_price.price_in_pence > 0 && line_item_price.exchange_info_presented != '' && (
                  <Tooltip key={line_item_price.exchange_info_presented} title={line_item_price.exchange_info_presented} />
                )}
              </td>
            </tr>
          )
        })}

        {config.show_price_for_one && (<>
          <tr className="tr-bordered-top">
            <td> {t('quote_builder.price_for_one')} </td>
            <td className="align-right"> {postOnChangeResponse.price_for_one_formatted}</td>
          </tr>

         {config.show_price_for_sheet && (
          <tr className="">
            <td> {t('quote_builder.price_for_sheet')} </td>
            <td className="align-right"> {postOnChangeResponse.price_for_sheet_formatted}</td>
          </tr>

          )}
          <tr className="">
            <td> {t('quote_builder.total')} </td>
            <td className="align-right"> {postOnChangeResponse.total_price_formatted}</td>
          </tr>
        </>)}

        {config.show_price_for_one != true && (<>
           <tr className="tr-bordered-top">
            <td> {t('quote_builder.total')} </td>
            <td className="align-right"> {postOnChangeResponse.total_price_formatted}</td>
          </tr>
        </>)}
      </tbody>
    </table>
  );
};

export default ResultsTable;